<template>
  <main class="projects" :class="loaded ? 'loaded' : loaded">
    <template v-if="projectsPage && Object.keys(projectsPage).length">
      <section class="padded page-header">
        <p class="catch-line" v-html="projectsPage[currentLang].mainTitle"></p>
        <p class="desc" v-html="setDescription(projectsPage[currentLang].description)"></p>
      </section>
      <transition name="fade">
        <section id="projects" class="padded" v-if="showGrid && projects">
           <div class="flex flex-wrap">
              <div v-for="(project, index) in projects" :key="project.uid" class="item" :data-index="index">
                  <router-link :to="{ path: definePath(project.uid) }" v-if="project.status == 'listed'">
                     <ProjectThumb :title="project[currentLang].title" :project='project' :currentLang="currentLang"/>
                  </router-link>
                  <ProjectThumb class="inactive" :title="project[currentLang].title+' – Coming soon'" v-if="project.status == 'unlisted'" :project='project' :currentLang="currentLang"/>
              </div>
            </div>
        </section>
      </transition>
      <ContactFooter 
        :currentLang="currentLang"
        :displayLogo="true"
        :isLandingMounted="landed"
        :site="site"/>
    </template>
  </main>
</template>

<script>
import {mapState} from 'vuex'
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imagesLoaded from 'vue-images-loaded'
import loaderHandler  from '@/mixins/loaderHandler.js'

const ProjectThumb = () => import( /* webpackChunkName: "ProjectThumb" */ '@/snippets/ProjectThumb.vue');
const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');

export default {
  props: ['currentLang'],
  name: 'ProjectsPage',
  directives: {
      imagesLoaded
  },
  computed: mapState(['site', 'projects', 'projectsPage']),
  mixins: [scrollBehavior, loaderHandler],
  metaInfo() {
    return {
      title: this.projectsPage.title,
       meta: [
        { name: 'description', content: null, },
        {
          property: 'og:description',
          content: null,
        },
        {
          property: 'og:url',
          content: this.site.url+this.$route.fullPath,
        },
      ]
    }
  },
  components:{
    ProjectThumb,
    ContactFooter
  },
  methods: {
    detectSmallDevice(){
      this.isSmallDevice = window.innerWidth < 1024 ? true : false;
    },
    displayImage(e){
      let el = e.target;
      setTimeout(
        function(){ el.classList = 'loaded';
      }, 500);
    },
    definePath(uid){
      return this.currentLang == 'fr' ? '/fr/realisations/'+uid : 'work/'+uid;
    },
    emitToApp(){
      this.$emit('mountedPage', {isBgLight : true});
    },
    setDescription(desc){
      this.$metaInfo.meta[0].description = this.$metaInfo.meta[1].description = desc;
      return desc;
    },
  },
  data(){
    return {
      showGrid: false,
      isSmallDevice: false,
      landed: false,
      options: {"columnWidth": '.grid-sizer', "itemSelector": ".item", percentPosition: true}
    }
  },
  mounted(){
    let self = this;
    this.emitToApp();
    this.displayComponent(200);
    setTimeout(function(){self.showGrid = true},300);
    setTimeout(function(){self.landed = true},3000);
    this.detectSmallDevice();
    window.addEventListener('resize', this.detectSmallDevice);
  }
}
</script>


<style lang="scss" scoped>
   main{
     min-height: 100vh;
     .page-header{
        opacity:0;
        @include transform(translate(0,10%));
        @include transition(opacity .5s ease, transform .3s ease);
     }
     &.loaded{
        .page-header{
          opacity:1;
          @include transform(translate(0,0));
        }
    }
    .desc{
      font-size: 1.7333333em;
      line-height: 1.5;
      letter-spacing: 0.16px;
      max-width:900px
    }
  }

  #projects{
    padding-top: 6rem;
    @media screen and (max-width:1200px){
      padding:1rem;
    }
    max-width:1600px;
    min-height:100vh;
    position:relative;
    margin:auto;
    .content{
      opacity:0;
      position:relative;
      @include transform(translate(0, 20%));
      @include transition(all .5s ease);
      &.display--grid{
        padding:0!important;
        opacity:1;
        @include transform(translate(0, 0));
        @media screen and (min-width:1200px){
          column-gap: 2rem;
        }
      }
    }

    .item{
      width:100%;
      padding:0 10px 10px;
      box-sizing: border-box;
      margin-bottom:30px;
      flex: 0 0 auto;
      @media screen and (min-width:767px){
        width: 25%;
        margin-bottom:0;
      }
    }
  }

   #app .projects .page-header{
    padding-bottom: 5.66667em!important;
    &:after{
      display:none;
    }
  }
</style>
